import { Variants } from '../types/variant';

export const endocrinologieWellplaceVariants = {
  endocrinologie_wellplace: {
    name: 'Endocrinologie Wellplace',
    status: 'restricted',
    availableInDemo: false,
    description:
      'Questionnaire de pré-consultation Wellplace pour le pôle Endocrinologie. Couvre première consultation et suivi (diabète, pathologies thyroïdiennes/hormonales, surpoids/obésité).',
    speciality: 'ENDOCRINOLOGIE-WELLPLACE',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'ENDOCRINOLOGY',
    visitMotivesSection: 'Motifs',
    initialQuestions: [],
    initialAssertions: ['[Médecin: #z‹]-(a_spécialité)->[Endocrinologie]'],
    pages: {
      ORIENTATION: {
        title: 'Orientation',
        sections: ['ORIENTATION'],
      },
      MOTIF: {
        title: 'Motif de consultation',
        sections: ['MOTIF_PREMIERE', 'MOTIF_SUIVI'],
      },
      COMMUNE: {
        title: 'Informations générales',
        sections: ['COMMUNE_PREMIERE', 'COMMUNE_SUIVI'],
      },
      SPECIFIQUE: {
        title: 'Questions spécifiques',
        sections: [
          'SPECIFIQUE_DIABETE_PREMIERE',
          'SPECIFIQUE_ENDOC_SURPOIDS_PREMIERE',
          'SPECIFIQUE_DIABETE_SUIVI',
          'SPECIFIQUE_SURPOIDS_SUIVI',
        ],
      },
      CONCLUSION: {
        title: 'Conclusion',
        sections: ['RECAP'],
      },
    },
    options: [],
  },
} satisfies Variants;
